/**
 * [getPubnubEnvironment]
 * Returns staging channel if stagex or staging, else default
 * @param env string from GOATENV_ENVIRONMENT
 */
export const getPubnubEnvironment = (env) => {
  if (env?.toLowerCase()?.includes('pr') && !env?.toLowerCase()?.includes('production')) {
    return 'staging';
  }

  return env;
};
